// extracted by mini-css-extract-plugin
module.exports = {"listContainer":"DiscipleList_listContainer__1SF-v","metaInfo":"DiscipleList_metaInfo__TFPSs","deleteIcon":"DiscipleList_deleteIcon__3lGwJ"};